module.exports = __webpack_public_path__ + "img/inverted-v.aa6b5a57e353f7e7a1b5078d9e864c76.jpg";